var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictureIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4226 0H3.45714C1.91457 0 0.664062 1.19924 0.664062 2.67857V17.4107C0.664062 18.89 1.91457 20.0893 3.45714 20.0893H17.4226C18.9651 20.0893 20.2156 18.89 20.2156 17.4107V2.67857C20.2156 1.19924 18.9651 0 17.4226 0Z",
    fill: "#DDEBFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6776 9.00969C15.5454 8.89055 15.3699 8.82546 15.1885 8.82821C15.0071 8.83096 14.8339 8.90133 14.7056 9.02442L11.6947 11.9126C11.5638 12.0382 11.4902 12.2085 11.4902 12.386C11.4902 12.5636 11.5638 12.7339 11.6947 12.8595L18.8331 19.7072C19.2528 19.4731 19.6012 19.1377 19.8439 18.7344C20.0866 18.3311 20.215 17.874 20.2164 17.4083V13.1005L15.6776 9.00969Z",
    fill: "#C37EFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5343 8.70536C13.6912 8.70536 14.6291 7.80593 14.6291 6.69643C14.6291 5.58693 13.6912 4.6875 12.5343 4.6875C11.3773 4.6875 10.4395 5.58693 10.4395 6.69643C10.4395 7.80593 11.3773 8.70536 12.5343 8.70536Z",
    fill: "#AC53F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83871 8.23527C8.7053 8.11429 8.52865 8.04688 8.34504 8.04688C8.16142 8.04688 7.98477 8.11429 7.85136 8.23527L0.664062 15.1279V17.4141C0.664063 18.1245 0.958333 18.8058 1.48214 19.3081C2.00594 19.8104 2.71637 20.0926 3.45714 20.0926H17.4225C17.9081 20.0913 18.3848 19.9682 18.8053 19.7354C19.2258 19.5027 19.5756 19.1685 19.8197 18.7661L8.83871 8.23527Z",
    fill: "#AC53F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictureIcon);
export default __webpack_public_path__ + "static/media/PictureIcon.72bf615db46a7e91b44799f297cad8a6.svg";
export { ForwardRef as ReactComponent };